import React from 'react';
import clsx from 'clsx';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Button from '@/elements/Button/Button.component';
import { IProps } from '@/blocks/SupportCta/SupportCta.interface';
import '@/blocks/SupportCta/SupportCta.styles.css';

export const SupportCta: React.FC<IProps> = ({
    title,
    button,
    className,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper
            className={clsx('supportCta', className)}
            {...blockWrapperProps}
            layout='hero'
            backgroundColor='brand-3'
        >
            <ContentWrapper>
                <ContentColumn className="supportCta__content">
                    {title && (
                        <Heading level={3} className="supportCta__title" html={title} />
                    )}
                    {button && <Button {...button} className='supportCta__button' />}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export default SupportCta;
